import Link from '@mui/material/Link';

export { Link };
